var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/bioplan_logo.png"),
      "role": "button"
    },
    on: {
      "click": _vm.goToArchive
    }
  })]), _vm._v(" "), (_vm.slidesLoading) ? _c('LoadingSpinner') : [_c('div', {
    staticClass: "slider",
    style: ({
      'background-image': 'url(' + _vm.currentSlide.url + ')'
    })
  }, [(_vm.hasPreviousSlide) ? _c('div', {
    staticClass: "left",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentSlideIndex--
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasNextSlide) ? _c('div', {
    staticClass: "right",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentSlideIndex++
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hasNextSlide) ? _c('div', {
    staticClass: "right",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.goToArchive
    }
  }) : _vm._e()])], _vm._v(" "), _c('div', {
    staticClass: "information"
  }, [_c('img', {
    staticClass: "signet",
    attrs: {
      "src": require("../../assets/img/bioplan_signet.png")
    }
  }), _vm._v(" "), (_vm.currentSlide) ? _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.currentSlide.title))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.currentSlide.description))])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495eba8d","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/HomeSlider.vue
// module id = 167
// module chunks = 1